import { FC } from 'react';
import { FillingExperienceProps } from '../../filling-experience.type';
import { FillingExperienceWrapper } from '../../provider';

export const Template: FC<FillingExperienceProps> = (props) => {
  return (
    <FillingExperienceWrapper {...props} experienceType='public' documentType='template' isPreviewMode={true}>
      <div>Template preview coming soon!</div>
    </FillingExperienceWrapper>
  );
};
